import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ScrollDirective} from './scroll.directive';
import {ResizeDirective} from './resize.directive';
import {DebouncedDirective} from './Debounced.directive';
import {ThrottleDirective} from './Throttle.directive';
import { EllipsisDirective } from './ellipsis.directive';

const Directive = [
  ScrollDirective,
  DebouncedDirective,
  ThrottleDirective,
  ResizeDirective,
  EllipsisDirective,
];

@NgModule({
  declarations: [
    Directive,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    Directive
  ]
})
export class DirectiveModule {
}
